import React, { useState } from 'react';

const PageLoading = () => {
    const [isHide, setIsHide] = useState(true);
    setTimeout(() => setIsHide(false), 2000);
    return (
        <div className="m-3" id="pageLoadSpinner">
            {!isHide ? <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i> : null}
        </div>
    );
};

export default PageLoading;
